var _g, _g2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketMapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1989_9794)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5183,
    cy: 39.5781,
    rx: 5.1726,
    ry: 1.84736,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_9794)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5178 3C28.0881 3 35.0356 9.94756 35.0356 18.5178C35.0356 25.0889 30.9513 30.7061 25.1828 32.9691L20.4017 39.5043C20.302 39.6411 20.1696 39.7528 20.0158 39.8298C19.862 39.9069 19.6912 39.9472 19.5178 39.9472C19.3445 39.9472 19.1736 39.9069 19.0198 39.8298C18.866 39.7528 18.7336 39.6411 18.634 39.5043L13.8528 32.9691C8.08433 30.7061 4 25.0889 4 18.5178C4 9.94756 10.9476 3 19.5178 3Z",
    fill: "#00A997"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1241 18.562C32.1241 11.6242 26.4999 6 19.562 6C12.6242 6 7 11.6242 7 18.562C7 25.4999 12.6242 31.1241 19.562 31.1241C26.4999 31.1241 32.1241 25.4999 32.1241 18.562Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5003 19.8333V25.6667C27.5003 26.1269 27.1272 26.5 26.667 26.5H13.3337C12.8734 26.5 12.5003 26.1269 12.5003 25.6667V19.8333H11.667V18.1667L12.5003 14H27.5003L28.3337 18.1667V19.8333H27.5003ZM14.167 19.8333V24.8333H25.8337V19.8333H14.167ZM15.0003 20.6667H21.667V23.1667H15.0003V20.6667ZM12.5003 11.5H27.5003V13.1667H12.5003V11.5Z",
    fill: "#F4B400"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_9794",
    x: 12.8678,
    y: 36.2528,
    width: 13.3005,
    height: 6.65064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.738955,
    result: "effect1_foregroundBlur_1989_9794"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_9794",
    x: 0.305226,
    y: 0.0441809,
    width: 38.4247,
    height: 44.3368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.738955
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_9794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_9794",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketMapIcon);
export default __webpack_public_path__ + "static/media/MarketMapIcon .e1e90a5680fe7e0783ad5eafd1e22bce.svg";
export { ForwardRef as ReactComponent };